import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetInvoiceItemStatisticsController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetInvoiceItemStatisticsController.php
* @route '/api/analytics/invoice-item/statistics'
*/
const GetInvoiceItemStatisticsController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetInvoiceItemStatisticsController.url(options),
    method: 'post',
})

GetInvoiceItemStatisticsController.definition = {
    methods: ["post"],
    url: '/api/analytics/invoice-item/statistics',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetInvoiceItemStatisticsController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetInvoiceItemStatisticsController.php
* @route '/api/analytics/invoice-item/statistics'
*/
GetInvoiceItemStatisticsController.url = (options?: RouteQueryOptions) => {
    return GetInvoiceItemStatisticsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetInvoiceItemStatisticsController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetInvoiceItemStatisticsController.php
* @route '/api/analytics/invoice-item/statistics'
*/
GetInvoiceItemStatisticsController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetInvoiceItemStatisticsController.url(options),
    method: 'post',
})

export default GetInvoiceItemStatisticsController